import Repository from './Repository';
import ListRequest from '@/models/ListRequest';
import { IngredientCost } from '@/models/IngredientCost/IngredientCost';

const resource = '/ingredientCosts';

export default {
    listIngredientCost(listRequest: ListRequest) {
        return Repository.post(`${resource}/ListIngredientCosts`, listRequest, { withCredentials: true });
    },
    listIngredientCostVendors() {
        return Repository.get(`${resource}/ListIngredientCostVendors`, { withCredentials: true });
    },
    createIngredientCosts(ingredientCosts: IngredientCost[]) {
        return Repository.post(`${resource}/CreateIngredientCosts`, { ingredientCosts: ingredientCosts }, { withCredentials: true });
    },
    createIngredientCostVendor(name: string) {
        return Repository.post(`${resource}/CreateIngredientCostVendor`, { name: name }, { withCredentials: true });
    },
    updateIngredientCost(ingredientCost: IngredientCost) {
        return Repository.post(`${resource}/UpdateIngredientCost`, ingredientCost, { withCredentials: true });
    },
    deleteIngredientCost(id: number) {
        return Repository.post(`${resource}/DeleteIngredientCost`, { id: id }, { withCredentials: true });
    },
    uploadIngredientCosts(formData: FormData) {
        return Repository.post(`${resource}/UploadIngredientCosts`, formData, { withCredentials: true });
    },
    loadMeasurementsForIngredientCost(data: any) {
        return Repository.post(`${resource}/LoadMeasurementsForIngredientCost`, data, { withCredentials: true });
    }
}
